import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { HierarchyNode } from './hierarchy-node';

export type HierarchyNodesResults = {
  total: number;
  nodes: HierarchyNode[];
};

@Injectable()
export class NodeService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  searchNodes(
    searchTerm: string,
    limit: number,
  ): Observable<HierarchyNodesResults> {
    const params = { searchTerm, limit };
    return this.tarlV3Jsonapi
      .getPageOfResources<HierarchyNode>('/nodes', params)
      .pipe(
        map(pageOfNodes => {
          const { data: nodes, meta } = pageOfNodes;
          return { nodes, total: meta.total };
        }),
      );
  }
}
